import { unfollowMember, followMember } from '../common/store/member-follow/member-follow-actions';
import { revealLiveComments, revealLiveReplies, someoneIsTyping, iAmTyping, } from '../common/store/comments/live-updates/live-updates-actions';
import { createReply, editReplyCreateError, updateReply, deleteReply, cancelCreatingReply, cancelEditingReply, editReply, initReply, } from '../common/store/comments/replies/replies-crud-actions';
import { showJoinCommunityPopup } from '../common/store/actions/join-community';
import { reactToComment } from '../common/store/comments/reactions/comments-reaction-actions';
import { markComment } from '../common/store/comments/mark/mark-actions';
import { voteOnComment } from '../common/store/comments/votes/comments-vote-actions';
import { createComment, editCommentCreateError, retryCreateComment, editComment, cancelCreatingComment, cancelEditingComment, updateComment, deleteComment, } from '../common/store/comments/top-level-comments/top-level-comments-crud-actions';
import { fetchComments, bulkFetchComments, fetchDeepLink, fetchNextComments, fetchPrevComments, fetchNextReplies, fetchPrevReplies, changeOrdering, refetchCommentsData, viewReplyTarget, unmountAllResources, fetchInteractions, } from '../common/store/comments/paging/comments-paging-actions';
import { biOpenCommentActions, biSelectCommentAction, biDiscardComment, biShowZeroCommentsEmptyState, biShowFallbackState, biInitiateFileUpload, biInitiateImageUpload, biAttemptLoginSignup, biClickShowMoreBtn, biClickPublishSelectBtn, biCommentFormExpanded, biOpenReactionList, biClickEmotionListTab, biShowCommentReplySubmissionWarning, } from '../common/store/actions/bi-actions';
import { tryCloseAllCommentBoxes, tryOpenCommentBox, } from '../common/store/comments/effects/comment-box-actions';
import { showToast } from '../common/store/comments/effects/show-toast-action';
import { resourceComponentUnmounted, resourceComponentMounted, } from '../common/store/comments/lifecycle/lifecycle-actions';
import { setInputRating } from '../common/store/comments/ratings/ratings-actions';
import { requestLogin } from '../common/store/actions/request-login';
import { fetchInitialHistory, fetchNextHistory, } from '../common/store/comments/history/history-actions';
import { reportComment } from '../common/store/comments/report/report-actions';
export const controllerActions = {
    fetchComments,
    bulkFetchComments,
    refetchCommentsData,
    fetchDeepLink,
    fetchNextComments,
    fetchPrevComments,
    fetchNextReplies,
    fetchPrevReplies,
    fetchInteractions,
    createComment,
    editCommentCreateError,
    editComment,
    cancelCreatingComment,
    cancelEditingComment,
    updateComment,
    retryCreateComment,
    createReply,
    editReplyCreateError,
    updateReply,
    deleteReply,
    cancelCreatingReply,
    cancelEditingReply,
    editReply,
    initReply,
    deleteComment,
    reactToComment,
    markComment,
    changeOrdering,
    viewReplyTarget,
    unmountAllResources,
    showJoinCommunityPopup,
    biOpenCommentActions,
    biSelectCommentAction,
    biDiscardComment,
    biShowZeroCommentsEmptyState,
    biShowFallbackState,
    biInitiateFileUpload,
    biInitiateImageUpload,
    biAttemptLoginSignup,
    biClickShowMoreBtn,
    biClickPublishSelectBtn,
    biCommentFormExpanded,
    biOpenReactionList,
    biClickEmotionListTab,
    showToast,
    revealLiveComments,
    revealLiveReplies,
    someoneIsTyping,
    iAmTyping,
    followMember,
    unfollowMember,
    voteOnComment,
    reportComment,
    tryOpenCommentBox,
    tryCloseAllCommentBoxes,
    resourceComponentUnmounted,
    resourceComponentMounted,
    setInputRating,
    requestLogin,
    fetchInitialHistory,
    fetchNextHistory,
    biShowCommentReplySubmissionWarning,
};
//# sourceMappingURL=controller-actions.js.map